import APP from 'src/main.js'
import InvestmentAggregation from './InvestmentAggregation.js'
import IssueAggregation from './IssueAggregation'

class AssetClassInvestment extends InvestmentAggregation {
  get name(){
    return this._name||this.asset_class
  }
  set name(v){
    this._name = v
  }
  get investments(){
    return this._investments||[]
  }
  set investments(external_investments){
    var invs
    if((this.asset_class != 'Honorar') && (this.asset_class != 'Kontant') && (this.asset_class != 'Buffer')){
      invs = external_investments.filter(inv => inv.type === 'IssueInvestment')
      let issue_ids = [... new Set(invs.map(inv => inv.issue_id))]
      var subset
      invs = issue_ids.map((id) => {
        subset = invs.filter(inv => inv.issue_id === id)
        if(subset.length > 1){
          let iag = new IssueAggregation({investments: subset, entity_id: this.entity_id})
          iag.compressIrs()
          return iag
        } else {
          return subset
        }
      }).flat(Infinity)
    } else {
      invs = external_investments
    }
    this._investments = invs
  }
}

export default AssetClassInvestment
